
/**
 * CreateInspecaoPatrimonioUseCase
 */

import { ICreateInspecaoPatrimonioUseCase } from "../../../presentation/useCases/create/create_inspecao_patrimonio_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

export class CreateInspecaoPatrimonioUseCase implements ICreateInspecaoPatrimonioUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async createInspecaoPatrimonio(
    idPatrimonioMaquinaEquip: number | null,
    dataInspecao: Date | null,
    descricao: string | null,
  ): Promise<number> {
    return await this.repository.createInspecaoPatrimonio(
      idPatrimonioMaquinaEquip,
      dataInspecao,
      descricao,
    );
  }
}
